import { BEMBlock } from 'helpers/classnames';
import React, { useRef } from 'react';
import { usePaletteConfig } from 'palette/Config';
import { MAIN_MENU_ID } from 'palette/HeaderDropdown/constants/menuIds';
import { Icon } from 'palette/Icon';
import { MenuItem } from './MainHeaderNavBar';
import MainHeaderNavBarItemContent from './MainHeaderNavBarItemContent';
import './styles/MainHeaderNavBarItem.scss';

interface MainHeaderNavBarItemProps {
    menuItem: MenuItem;
    isDropdownOpen: boolean;
    onClick: (event: React.MouseEvent<HTMLAnchorElement>, menuItem: MenuItem) => void;
    onLinkHover: (menuItem: MenuItem, index: number) => void;
    onFocus?: (menuItem: MenuItem) => void;
    index: number;
}

export function MainHeaderNavBarItem({
    menuItem,
    index,
    isDropdownOpen,
    onClick,
    onFocus,
    onLinkHover,
}: MainHeaderNavBarItemProps) {
    const { translate } = usePaletteConfig();
    const ref = useRef<HTMLAnchorElement | HTMLDivElement>();
    const {
        hasDropdown,
        url,
        tag,
        isExternal,
        isSelected,
        navigationId: id,
        label,
        attributes,
    } = menuItem;

    const navBarItemContentProps = {
        label, isExternal, tag, isSelected,
    };

    const [block, BEMElement] = BEMBlock('main-header-nav-bar-item');

    return (
        <li
            className={block}
            id={id}
            {...attributes}
        >
            {url ? (
                <a
                    ref={ref as React.RefObject<HTMLAnchorElement>}
                    className={BEMElement('link')}
                    href={url}
                    {...isExternal && {
                        target: '_blank',
                        rel: 'noopener',
                    }}
                    tabIndex={0}
                    onClick={e => onClick(e, menuItem)}
                    onFocus={() => onFocus?.(menuItem)}
                    onMouseOver={() => onLinkHover(menuItem, index)}
                >
                    <MainHeaderNavBarItemContent
                        {...navBarItemContentProps}
                    />
                </a>
            ) : (
                <MainHeaderNavBarItemContent
                    {...navBarItemContentProps}
                    ref={ref as React.RefObject<HTMLDivElement>}
                    className={BEMElement('content')}
                    tabIndex={0}
                    onMouseOver={() => onLinkHover(menuItem, index)}

                />
            )}
            {hasDropdown && (
                <button
                    aria-controls={MAIN_MENU_ID}
                    aria-expanded={isDropdownOpen}
                    aria-haspopup="dialog"
                    aria-label={[label, translate('header.menu.label')].join(' ')}
                    className={BEMElement('dropdown-trigger')}
                    onClick={() => onLinkHover(menuItem, index)}
                >
                    <Icon
                        name="palette_chevron_down"
                        size="x-small"
                    />
                </button>
            )}
        </li>
    );
}
